import apiTool from './index';

const GET_LANGUAGES_URL = 'translation/get-languages/';
const SWITCH_LANGAUGE_URL = 'translation/switch-language-url/';

export default {
  getLanguages() {
    console.log("i call the api");
    return apiTool.get(GET_LANGUAGES_URL);
  },
  switchLanguage(payload) {
    return apiTool.post(SWITCH_LANGAUGE_URL, payload);
  }
};
